import { Device_State } from './enums';
import { ModelCommon, UserAttributeDef, UserAttributeDefs, toDatePickerFormat, ValidModelType } from '@iotv/datamodel-core';
import { isValidBusinessObject, MapLike, PathDirection } from '@iotv/iotv-v3-types';

const typeName = 'WaterPumpReadings';

export type WaterPumpReadingsProps = {
  flow?: number;
  volumePumped?: number;
  pumpPressure?: number;
  operatingStatus?: Device_State;
  pumpStartTime?: number;
  pumpStopTime?: number;
  costRate?: number;
  totalCost?: number;
  pumpOperationEventDuration?: number;
};

export class WaterPumpReadings extends ModelCommon {
  constructor(ob: any) {
    super(ob.type || typeName, ob);
  }

  flow?: number;
  volumePumped?: number;
  pumpPressure?: number;
  operatingStatus?: Device_State;
  pumpStartTime?: number;
  pumpStopTime?: number;
  costRate?: number;
  totalCost?: number;
  pumpOperationEventDuration?: number;

  getUserAttributes(): UserAttributeDefs {
    return {
      ...super.getUserAttributes(),
      flow: { type: 'Number', editable: true, label: 'Flow', name: 'flow', description: 'Water flow  litres/ sec and cubic metres/ sec' },
      volumePumped: { type: 'Number', editable: true, label: 'Volume Pumped', name: 'volumePumped', description: 'Litres, cubic metres' },
      pumpPressure: { type: 'Number', editable: true, label: 'Pump Pressure', name: 'pumpPressure', description: 'Current pump pressure PSi' },
      operatingStatus: { type: 'Enum', editable: true, label: 'Operating Status', name: 'operatingStatus', description: 'On/ off', enumKv: Device_State },
      pumpStartTime: { type: 'Number', editable: true, label: 'Pump Start Time', name: 'pumpStartTime', description: 'Date and time of pump start' },
      pumpStopTime: { type: 'Number', editable: true, label: 'Pump Stop Time', name: 'pumpStopTime', description: 'Date and time of pump stop' },
      costRate: { type: 'Number', editable: true, label: 'Cost Rate', name: 'costRate', description: 'Cost of water at the pumps rating' },
      totalCost: { type: 'Number', editable: true, label: 'Total Cost', name: 'totalCost', description: 'Cost due to the pump over this duration' },
      pumpOperationEventDuration: {
        type: 'Number',
        editable: true,
        label: 'Pump Operation Event Duration',
        name: 'pumpOperationEventDuration',
        description: 'Duration between pump start and pump stop - hours/ minutes',
      },
    };
  };
}
